/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { storyblokInit, apiPlugin } from 'gatsby-source-storyblok';
import configuration from '../../../gatsby-config';
import '../../../i18n';

import { Notifications } from '../notifications';
import MainMenu from '../header/mainMenu';
import Footer from '../footer/footer';
import { useBookingContext } from '../../contexts/bookingContext';

import components from './components';

const sbConfig = configuration.plugins.find(
  (item) => item.resolve === 'gatsby-source-storyblok',
);

storyblokInit({
  accessToken: sbConfig.options.accessToken,
  use: [apiPlugin],
  bridge: true,
  cache: {
    clear: 'auto',
  },
  components: components,
});

const Layout = ({ children }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const { isFullscreenModal } = useBookingContext();

  useEffect(() => {
    if (isFullscreenModal) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.overflow = 'auto';
    }
  }, [isFullscreenModal]);
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  return (
    <div>
      <MainMenu
        mobileMenuOpen={mobileMenuOpen}
        toggleMobileMenu={toggleMobileMenu}
      />
      {children}
      <Footer />
      <Notifications />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
